"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformRawIssueAttributes = exports.IssueTemplateMigration = void 0;
var _omit = _interopRequireDefault(require("lodash/omit"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const transformRawIssueAttributes = rawIssueAttributes => {
  const templateIssueAttributes = {
    ...(0, _omit.default)(rawIssueAttributes, ["issueTypeId", "issueSubtypeId"]),
    typeId: rawIssueAttributes.issueSubtypeId,
    categoryId: rawIssueAttributes.issueTypeId
  };
  if (!templateIssueAttributes.title) {
    templateIssueAttributes.title = "";
  }
  // a template with just an assignee and no assignedToType cannot yet be handled
  // by our frontend app, so we make sure to strip it. This is only a problem with some old data.
  // Ideally, we wouldn't need assignedToType at all and we could rely on the assignee info to populate
  // that data, but it is not yet built to depend on the assignee store in that way.
  if (!rawIssueAttributes.assignedToType && templateIssueAttributes.assigneeId) {
    delete templateIssueAttributes.assigneeId;
    console.warn("Template has assigneeId but no assignedToType: this is a problem that should only occur with test data", templateIssueAttributes);
  }
  return templateIssueAttributes;
};
exports.transformRawIssueAttributes = transformRawIssueAttributes;
const IssueTemplateMigration = exports.IssueTemplateMigration = {
  serialize: issueTemplate => {
    return {
      issueAttributes: {
        ...(0, _omit.default)(issueTemplate.issueAttributes, ["typeId", "categoryId"]),
        issueTypeId: issueTemplate.issueAttributes.categoryId,
        issueSubtypeId: issueTemplate.issueAttributes.typeId
      },
      isActive: issueTemplate.isActive
    };
  },
  deserialize: rawIssueTemplate => ({
    ...(0, _omit.default)(rawIssueTemplate, ["containerId", "issueTemplateCategoryId"]),
    projectId: rawIssueTemplate.containerId,
    issueAttributes: transformRawIssueAttributes(rawIssueTemplate.issueAttributes)
  })
};
//# sourceMappingURL=IssueTemplateMigration.js.map